import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import {CommentListResultVo} from '../../common/shared/api/nicolas/vo/comment/CommentListResultVo.interface';

/**
 * 내 댓글 목록 조회
 *
 * Origin: pageNicolasApi.getMyCommentList
 * API: GET /api/v8/store/community/mycommentlist
 */
export async function getStoreCommunityMycommentlist(
  page: number,
  options?: FetcherOptions
): Promise<ApiResultV2Vo<CommentListResultVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v8/store/community/mycommentlist',
    {
      method: 'GET',
      params: {
        page,
      },
    },
    options
  );
  return response.data;
}
